<script>
export default {
    name: 'SubscriptionExpiry'
}
</script>

<template>
    <div
        class="py-3 px-4 mb-3 text-sm text-rss-button-red-700 bg-rss-button-red-200 rounded border-2 border-rss-button-red-300/50"
    >
        <span
            class="message"
            v-html="$page.props.flash.subscription"
        />
    </div>
</template>

<style scoped>
.message /deep/ a {
    font-weight: 500;
}

.message /deep/ a:hover {
    text-decoration: underline;
}
</style>
